import script from "./PlanningKpiCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlanningKpiCard.vue?vue&type=script&setup=true&lang=ts"

import "./PlanningKpiCard.vue?vue&type=style&index=0&id=4cc74896&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cc74896"]])

export default __exports__